import Service from '../Service'
import _ from 'lodash'
import { API_BASE_URL } from '@/config/environment'

class PageService extends Service {
  
  static request = {}
  
  requestMutation (request) {
    console.log('request', request)
    PageService.request = {}
    request.filter = { ..._.pickBy(request.params, _.identity) }
    console.log('request filter', request.filter)
    PageService.request = request
    return this
  }

  get (name) {
    return this[name]
  }

  get mainEconomicIndicator () {
    return this.globalState.js.$http.get(`${API_BASE_URL}/fetch`, { params: PageService.request })
  }

  get internationalRatings () {
    return this.globalState.js.$http.get(`${API_BASE_URL}/rating`, { params: PageService.request })
  }

  get barChartData () {
    return this.globalState.js.$http.get(`${API_BASE_URL}/bar-chart`, { params: PageService.request })
  }

}

PageService.id = 'PageService'

export default PageService


